module.exports = "/images/spot-ph.png?8d2bda4adb279704ef6c06d5c69f9bd3";